export default {
  PAYMENT: "पेमेंट",
  PAYMENTS: "पेमेंट्स",
};
